const getImageSrc = imageUrl =>
  imageUrl
    ? `${process.env.MEDIA_API_URL}/fetch/${encodeURIComponent(
        imageUrl,
      )}/transform~rs_w.256?fallback=${process.env.MEDIA_API_DEFAULT_IMAGE_ID}`
    : `${process.env.MEDIA_API_URL}/${process.env.MEDIA_API_DEFAULT_IMAGE_ID}`;

export default getImageSrc;
